import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { UNIFIED_FEED_DOMAIN_SERVICE } from 'constants/index';
import _get from 'lodash.get';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import makeRequest from 'utils/makeRequest';
import Cookie from 'utils/cookies';
import Text from 'components_v2/common/Text';
import classnames from 'classnames';
import AdCaller from 'helpers/ads/adCaller';
import s from './BiharBoardResult.scss';
import BoardResultDisplay from './BoardResultDisplay.js';

const BoardForm = props => {
  const {
    data,
    seoData,
    isWapView,
    location,
    hideBtf,
    fromIframe,
    origin,
    userData,
  } = props;
  if (!data) {
    return null;
  }
  const {
    form_fields,
    atfFormText,
    btfFormText,
    resultDeclarationState,
    result_dtl_url,
    query_map,
    t_c,
    htmlContentText = '',
    event_post_url,
    // msid,
    stateName,
    className,
    ga_type,
  } = data;

  const classText = className ? `${className}th` : '';

  const formRef = useRef(null);

  const genderDefaultValue = 'male';

  const isUserLoggedIn = !!(userData && userData.isLoggedIn);

  const scrollToTop = () => {
    if (formRef.current) {
      try {
        const offset = 200;
        const targetPosition = formRef.current.getBoundingClientRect().top;
        const currentPosition = window.scrollY;
        const scrollToPosition = targetPosition + currentPosition - offset;

        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth',
        });
      } catch (e) {
        console.log('error while scrolling');
      }
    }
  };

  const isNumberValid = numberInput => {
    const regex = /^[0-9]+$/;
    return regex.test(numberInput);
  };

  const isValidNumber = numberInput => {
    const regex = /^[0-9]+$/;
    if (typeof numberInput !== 'string' || numberInput.length !== 6) {
      return false;
    }
    return regex.test(numberInput);
  };

  const isAlphanumericValid = numberInput => {
    const alphanumericRegex = /^[a-zA-Z0-9]+$/;
    return alphanumericRegex.test(numberInput);
  };

  const isEmailValid = email => {
    let validemail = true;
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );
    if (!pattern.test(email)) {
      validemail = false;
    }
    return validemail;
  };

  const isValidMobileNumber = number => {
    const regex = /^\d{10}$/; // This regex matches exactly 10 digits
    return regex.test(number);
  };

  const isValidFullName = name => {
    if (!(name && typeof name === 'string')) {
      return false;
    }
    const maxLength = 70;
    const regex = /^[A-Za-z\s\-']+$/; // Allows letters, spaces, hyphens, and apostrophes

    return name.length > 0 && name.length <= maxLength && regex.test(name);
  };

  const [userNameInput, setUserNameInput] = useState('');
  const [isUserNameValid, setIsUserNameValid] = useState(false);

  const [userEmailInput, setUserEmailInput] = useState('');
  const [isUserEmailValid, setIsUserEmailValid] = useState(false);

  const [userMobileInput, setUserMobileInput] = useState('');
  const [isUserMobileValid, setIsUserMobileValid] = useState(false);

  const [rollcodeInput, setRollcodeInput] = useState('');
  const [isRollcodeValid, setIsRollcodeValid] = useState(false);

  const [dobInput, setDobInput] = useState('');
  const [isDobValid, setIsDobValid] = useState(false);

  const [rollnoInput, setRollnoInput] = useState('');
  const [isRollnoValid, setIsRollnoValid] = useState(false);

  const [appnoInput, setAppnoInput] = useState('');
  const [isAppnoValid, setIsAppnoValid] = useState(false);

  const [regnoInput, setRegnoInput] = useState('');
  const [isRegnoValid, setIsRegnoValid] = useState(false);

  const [genderInput, setGenderInput] = useState(genderDefaultValue);
  const [isGenderValid, setIsGenderValid] = useState(genderInput !== '');

  const [isResultNotFound, setIsResultNotFound] = useState(false);
  const [showResultAwaitedMessage, setShowResultAwaitedMessage] = useState(
    false,
  );

  // eslint-disable-next-line no-unused-vars
  const [showResultPage, setShowResultPage] = useState(false);
  const [showErrorMessages, setShowErrorMessages] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [isUserDetailsSaved, setIsUserDetailsSaved] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  // const resultInfoText =
  //   location && typeof location === 'string' && location.includes('10th')
  //     ? '10th'
  //     : '12th';

  const getResultNotFoundText = () => {
    const {
      roll_code,
      roll_number,
      app_number,
      registration_number,
    } = form_fields;
    let text = 'Please check your ';

    if (roll_code)
      text += `roll code${
        roll_number || app_number || registration_number ? '/' : ''
      }`;
    if (roll_number)
      text += `roll no.${app_number || registration_number ? '/' : ''}`;
    if (app_number) text += `application no.${registration_number ? '/' : ''}`;
    if (registration_number) text += 'registration no.';

    return text;
  };
  const fireClickGa = category => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: data && data.ga_type,
      label: data && data.title,
      category,
      origin: fromIframe && origin ? origin : '',
    });
  };

  const resetForm = () => {
    setUserNameInput('');
    setIsUserNameValid(false);
    setUserEmailInput('');
    setIsUserEmailValid(false);
    setUserMobileInput('');
    setIsUserMobileValid(false);
    setRollnoInput('');
    setIsRollnoValid(false);
    setAppnoInput('');
    setIsAppnoValid(false);
    setRegnoInput('');
    setIsRegnoValid(false);
    setRollcodeInput('');
    setIsRollcodeValid(false);
    setDobInput('');
    setIsDobValid(false);
    setGenderInput(genderDefaultValue);
    setIsGenderValid(true);
    setShowErrorMessages(false);
    setShowResultPage(false);
    setIsResultNotFound(false);
    setShowResultAwaitedMessage(false);
    setResultData(undefined);
    fireClickGa('check_other_result');
  };

  useEffect(() => {
    if (data && !(data.hideForm === '1')) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: data && data.ga_type,
        label: data && data.title,
        origin: fromIframe && origin ? origin : '',
      });
    }
  }, []);

  const fireSubmitGa = () => {
    analyticsWrapper('ga4', {
      event: 'form_submit',
      type: data && data.ga_type,
      label: data && data.title,
      origin: fromIframe && origin ? origin : '',
    });
  };

  function generateURL(queryMap, internalMap, baseUrl) {
    let updatedUrl = baseUrl;
    Object.keys(queryMap).forEach(key => {
      const placeholder = queryMap[key];
      const value = internalMap[key];
      if (value) {
        updatedUrl = updatedUrl.replace(new RegExp(placeholder, 'g'), value);
      }
    });

    return updatedUrl;
    // return 'https://psn.timesofindia.com/events-manager/result/get?rollnumber=1230000001&rollcode=&rt=up_10';
  }

  const fireSaveUserDetails = () => {
    const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId');
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/utility/user/post/data?pc=toi&pfm=web&tag=${ga_type}`;
    const requestParams = {
      headers: {
        'Content-Type': 'application/json',
        ssoId,
      },
    };
    const postData = {
      // email, mobile, board, class, date against the SSO
      name: userNameInput || '',
      email: userEmailInput || '',
      mobile: userMobileInput || '',
      board: stateName || '',
      class: className || '',
      dob: dobInput || '',
    };
    if (ssoId) {
      makeRequest
        .post(url, postData, requestParams)
        .then(() => {
          setIsUserDetailsSaved(true);
        })
        .catch(() => {
          console.log('error while saving user details');
        });
    }
  };

  const onSubmit = () => {
    if (
      !(
        ((form_fields && form_fields.email && isUserEmailValid) ||
          !(form_fields && form_fields.email)) &&
        ((form_fields && form_fields.name && isUserNameValid) ||
          !(form_fields && form_fields.name)) &&
        ((form_fields && form_fields.mobile_number && isUserMobileValid) ||
          !(form_fields && form_fields.mobile_number)) &&
        // isRollcodeValid &&
        ((form_fields && form_fields.roll_number && isRollnoValid) ||
          !(form_fields && form_fields.roll_number)) &&
        ((form_fields && form_fields.app_number && isAppnoValid) ||
          !(form_fields && form_fields.app_number)) &&
        ((form_fields && form_fields.registration_number && isRegnoValid) ||
          !(form_fields && form_fields.registration_number)) &&
        ((form_fields && form_fields.gender && isGenderValid) ||
          !(form_fields && form_fields.gender))
      )
    ) {
      setShowErrorMessages(true);
      return;
    }

    if (
      resultDeclarationState &&
      resultDeclarationState === 'announced' &&
      result_dtl_url
    ) {
      setIsSubmitDisabled(true);
      const internalMap = {
        rollNumber: rollnoInput || '',
        rollCode: rollcodeInput || '',
        appNumber: appnoInput || '',
        registrationNumber: regnoInput || '',
        dob: dobInput || '',
      };
      makeRequest
        .get(
          generateURL(query_map, internalMap, result_dtl_url),
          {},
          'skipfeedengine',
        )
        .catch(() => {
          setIsResultNotFound(true);
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: data && data.ga_type,
            label: `Result not found! ${getResultNotFoundText()}`,
            origin: fromIframe && origin ? origin : '',
          });
          setIsSubmitDisabled(false);
        })
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            response.data.result_view_type &&
            (response.data.result_view_type === 'marksheet' ||
              response.data.result_view_type === 'grade')
          ) {
            setResultData({ ...response.data });
            setShowResultPage(true);
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: data && data.ga_type,
              label: data && data.title,
              category: 'result_shown',
              origin: fromIframe && origin ? origin : '',
            });
            scrollToTop();
            if (isUserLoggedIn) {
              fireSaveUserDetails();
            }
          } else {
            setIsResultNotFound(true);
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: data && data.ga_type,
              label: `Result not found! ${getResultNotFoundText()}`,
              origin: fromIframe && origin ? origin : '',
            });
          }
          setIsSubmitDisabled(false);
        });
    }

    const uid = Cookie.get('_col_uuid');
    const postData = {
      name: userNameInput || '',
      class: classText || '',
      email: userEmailInput || '',
      mobile: userMobileInput || '',
      rollnumber: rollnoInput || '',
      appnumber: appnoInput || '',
      regnumber: regnoInput || '',
      gender: genderInput || '',
      rollcode: rollcodeInput || '',
      dob: dobInput || '',
      columbia_id: uid || '',
    };
    if (event_post_url) {
      makeRequest.post(event_post_url, postData);
    }

    if (resultDeclarationState && resultDeclarationState === 'result_awaited') {
      setShowResultAwaitedMessage(true);
    }

    fireSubmitGa();
  };

  const handleInputTextChange = event => {
    if (event && event.target && event.target.id) {
      const inputVal = event.target.value;
      if (event.target.id === 'board-input-name') {
        const valid = isValidFullName(inputVal);
        setUserNameInput(inputVal);
        setIsUserNameValid(valid);
      } else if (event.target.id === 'board-input-rollno') {
        const valid = isNumberValid(inputVal);
        setRollnoInput(inputVal);
        setIsRollnoValid(valid);
      } else if (event.target.id === 'board-input-rollno-wb') {
        const valid = isAlphanumericValid(inputVal);
        setRollnoInput(inputVal);
        setIsRollnoValid(valid);
      } else if (event.target.id === 'board-input-appno') {
        const valid = isNumberValid(inputVal);
        setAppnoInput(inputVal);
        setIsAppnoValid(valid);
      } else if (event.target.id === 'board-input-regno') {
        const valid = isNumberValid(inputVal);
        setRegnoInput(inputVal);
        setIsRegnoValid(valid);
      } else if (event.target.id === 'board-input-dob') {
        const valid = isValidNumber(inputVal);
        setDobInput(inputVal);
        setIsDobValid(valid);
      } else if (event.target.id === 'board-input-rollcode') {
        const valid = isNumberValid(inputVal);
        setRollcodeInput(inputVal);
        setIsRollcodeValid(valid);
      } else if (event.target.id === 'board-input-email') {
        const valid = isEmailValid(inputVal);
        setUserEmailInput(inputVal);
        setIsUserEmailValid(valid);
      } else if (event.target.id === 'board-input-mobile') {
        const valid = isValidMobileNumber(inputVal);
        setUserMobileInput(inputVal);
        setIsUserMobileValid(valid);
      } else if (
        event.target.id === 'board-input-gender-male' ||
        event.target.id === 'board-input-gender-female' ||
        event.target.id === 'board-input-gender-others'
      ) {
        const valid = isValidFullName(inputVal);
        setGenderInput(inputVal);
        setIsGenderValid(valid);
      }
    }
  };

  const isResultPageVisible = showResultPage && resultData;

  const isMatricform = classText && classText === '10th';

  const isRajasthanBoardForm =
    data && (data.msid === 109063206 || data.msid === 109063180);

  const rollMobileRajasthan = (
    <>
      {form_fields &&
        form_fields.roll_number && (
          <div
            className={`${s.input_group} ${
              !isRollnoValid && showErrorMessages ? s.input_error : ''
            }`}
          >
            <div className={s.input_name}>
              Roll Number<sup>*</sup>
            </div>
            <input
              type="number"
              placeholder="Enter your Roll No."
              id="board-input-rollno"
              onChange={handleInputTextChange}
              value={rollnoInput}
            />
            {!isRollnoValid &&
              showErrorMessages && (
                <div className={s.error}>Please enter a valid Roll No.</div>
              )}
          </div>
        )}
      {form_fields &&
        form_fields.mobile_number && (
          <div
            className={`${s.input_group} ${
              !isUserMobileValid && showErrorMessages ? s.input_error : ''
            }`}
          >
            <div className={s.input_name}>
              Mobile Number<sup>*</sup>
            </div>
            <input
              type="number"
              placeholder="Enter your Mobile No."
              id="board-input-mobile"
              onChange={handleInputTextChange}
              value={userMobileInput}
            />
            {!isUserMobileValid &&
              showErrorMessages && (
                <div className={s.error}>Please enter a valid Mobile No.</div>
              )}
          </div>
        )}
    </>
  );
  const getFormHTML = () => (
    <>
      {data && data.title && <h1 className={s.main_heading}>{data.title}</h1>}
      {/* formHTML */}
      {!isResultPageVisible && (
        <>
          {atfFormText && <p className={s.info_text}>{atfFormText}</p>}
          <div className={s.form_container}>
            <div className={s.input_outer}>
              {isRajasthanBoardForm && !props.isWapView
                ? rollMobileRajasthan
                : null}
              {isRajasthanBoardForm && props.isWapView ? (
                <div className={s.roll_mobile}>{rollMobileRajasthan}</div>
              ) : null}
              {form_fields &&
                form_fields.name && (
                  <div
                    className={`${s.input_group} ${
                      !isUserNameValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Full Name<sup>*</sup>
                    </div>
                    <input
                      type="text"
                      id="board-input-name"
                      placeholder="Enter your Full Name"
                      onChange={handleInputTextChange}
                      value={userNameInput}
                    />
                    {!isUserNameValid &&
                      showErrorMessages && (
                        <div className={s.error}>Please enter a valid Name</div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.email && (
                  <div
                    className={`${s.input_group} ${
                      !isUserEmailValid && showErrorMessages
                        ? s.input_error
                        : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Email ID<sup>*</sup>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter your Email ID"
                      id="board-input-email"
                      onChange={handleInputTextChange}
                      value={userEmailInput}
                    />
                    {!isUserEmailValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid E-mail ID
                        </div>
                      )}
                  </div>
                )}

              {form_fields &&
                form_fields.mobile_number &&
                !isRajasthanBoardForm && (
                  <div
                    className={`${s.input_group} ${
                      !isUserMobileValid && showErrorMessages
                        ? s.input_error
                        : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Mobile Number<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your Mobile No."
                      id="board-input-mobile"
                      onChange={handleInputTextChange}
                      value={userMobileInput}
                    />
                    {!isUserMobileValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Mobile no.
                        </div>
                      )}
                  </div>
                )}

              {form_fields &&
                form_fields.roll_code && (
                  <div
                    className={`${s.input_group} ${
                      !isRollcodeValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Roll Code<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your Roll Code."
                      id="board-input-rollcode"
                      onChange={handleInputTextChange}
                      value={rollcodeInput}
                    />
                    {!isRollcodeValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Roll code
                        </div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.dob && (
                  <div
                    className={`${s.input_group} ${
                      !isDobValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      DOB<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your date of birth in (DDMMYY) format."
                      id="board-input-dob"
                      min="6"
                      max="6"
                      onChange={handleInputTextChange}
                      value={dobInput}
                    />
                    {!isDobValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid date of birth
                        </div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.roll_number &&
                data &&
                data.msid === 109398401 &&
                !isRajasthanBoardForm && (
                  <div
                    className={`${s.input_group} ${
                      !isRollnoValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Roll Number<sup>*</sup>
                    </div>
                    <input
                      type="text"
                      placeholder="Enter your Roll No."
                      id="board-input-rollno-wb"
                      onChange={handleInputTextChange}
                      value={rollnoInput}
                    />
                    {!isRollnoValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Roll Number
                        </div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.roll_number &&
                data &&
                data.msid !== 109398401 &&
                !isRajasthanBoardForm && (
                  <div
                    className={`${s.input_group} ${
                      !isRollnoValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Roll Number<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your Roll No."
                      id="board-input-rollno"
                      onChange={handleInputTextChange}
                      value={rollnoInput}
                    />
                    {!isRollnoValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Roll Number
                        </div>
                      )}
                  </div>
                )}

              {form_fields &&
                form_fields.app_number && (
                  <div
                    className={`${s.input_group} ${
                      !isAppnoValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Application Number<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your Application Number"
                      id="board-input-appno"
                      onChange={handleInputTextChange}
                      value={appnoInput}
                    />
                    {!isAppnoValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Application Number
                        </div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.registration_number && (
                  <div
                    className={`${s.input_group} ${
                      !isRegnoValid && showErrorMessages ? s.input_error : ''
                    }`}
                  >
                    <div className={s.input_name}>
                      Registration Number<sup>*</sup>
                    </div>
                    <input
                      type="number"
                      placeholder="Enter your Registration Number"
                      id="board-input-regno"
                      onChange={handleInputTextChange}
                      value={regnoInput}
                    />
                    {!isRegnoValid &&
                      showErrorMessages && (
                        <div className={s.error}>
                          Please enter a valid Registration Number
                        </div>
                      )}
                  </div>
                )}
              {form_fields &&
                form_fields.gender && (
                  <div className={`${s.input_group} ${s.input_group_radio}`}>
                    <div className={s.input_name}>
                      Gender<sup>*</sup>
                    </div>

                    <div
                      className={s.radio_label}
                      id="board-input-gender"
                      onChange={handleInputTextChange}
                    >
                      <label htmlFor="board-input-gender-male">
                        <input
                          type="radio"
                          name="gender"
                          id="board-input-gender-male"
                          value="male"
                          checked={genderInput === 'male'}
                          // onChange={handleInputTextChange}
                        />Male
                      </label>

                      <label htmlFor="board-input-gender-female">
                        <input
                          type="radio"
                          name="gender"
                          id="board-input-gender-female"
                          value="female"
                          checked={genderInput === 'female'}
                          // onChange={handleInputTextChange}
                        />Female
                      </label>

                      <label htmlFor="board-input-gender-others">
                        <input
                          type="radio"
                          name="gender"
                          id="board-input-gender-others"
                          value="others"
                          checked={genderInput === 'others'}
                          // onChange={handleInputTextChange}
                        />Others
                      </label>
                    </div>
                    {!isGenderValid &&
                      showErrorMessages && (
                        <div className={s.error}>Please select your Gender</div>
                      )}
                  </div>
                )}
            </div>

            <div className={s.submit_text}>
              <div className={s.btn_group}>
                <button
                  className={s.submit_btn}
                  type="submit"
                  onClick={onSubmit}
                  disabled={isSubmitDisabled}
                >
                  {isSubmitDisabled ? 'Submitting...' : 'Submit'}
                </button>
                {isResultNotFound && (
                  <div className={s.error}>
                    <span>Result not found!</span> {getResultNotFoundText()}
                  </div>
                )}
                {showResultAwaitedMessage && (
                  <div className={s.error}>
                    <span>Result Awaited</span>
                  </div>
                )}
              </div>
              {btfFormText && (
                <div className={`${s.info_text} ${s.f_12px}`}>
                  {btfFormText}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );

  const getTextHtml = () => (
    <>
      {data && data.title && <h1 className={s.main_heading}>{data.title}</h1>}
      <ul
        className={s.guideline}
        dangerouslySetInnerHTML={{
          __html: htmlContentText,
        }}
      />
      <div className={s.btn_group}>
        <a
          href={data && data.ctaLink ? data.ctaLink : '/'}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className={s.submit_btn}
        >
          CHECK YOUR RESULT <span />
        </a>
      </div>
    </>
  );

  const stateClassName = classnames({
    [`${s.up_board}`]: stateName && stateName === 'UP',
    [`${s.ap_board}`]: stateName && stateName === 'Andhra Pradesh',
    [`${s.mp_board}`]: stateName && stateName === 'MP',
    [`${s.wb_board}`]: stateName && stateName === 'WB',
    [`${s.rb_board}`]: stateName && stateName === 'Rajasthan',
  });

  return (
    <>
      <div className={`${s.resultpage_wrap} resultpage_wrap`} ref={formRef}>
        <div className={s.result_page}>
          <div
            className={`${s.lhs} ${
              stateName && stateName === 'Rajasthan' && props.isPrime
                ? s.prime_case
                : ''
            }`}
          >
            <div
              className={`${s.result_lhs} ${s.common_board} ${
                s.common_board_all
              }  ${stateClassName}`}
            >
              {!isResultPageVisible && (
                <>
                  {data && data.hideForm === '1'
                    ? getTextHtml()
                    : getFormHTML()}
                </>
              )}
              {isResultPageVisible && (
                <BoardResultDisplay
                  resultData={resultData}
                  isMatricform={isMatricform}
                  data={data}
                  resetForm={resetForm}
                  seoData={seoData}
                  fireClickGa={fireClickGa}
                  classText={classText}
                  rollnoInput={rollnoInput}
                  columnMapping={t_c}
                  isWapView={isWapView}
                  location={location}
                  msid={seoData && seoData.msid}
                  stateName={stateName}
                  fromIframe={fromIframe}
                  ga4Type={data.ga_type}
                  isUserDetailsSaved={isUserDetailsSaved}
                  fireSaveUserDetails={fireSaveUserDetails}
                />
              )}
            </div>
          </div>
          <div className={`${s.leftColSpacing}`}>
            <div className={s.rhsstickybox}>
              {!props.isPrime &&
                data &&
                data.adCode && (
                  <div className="paisa-wrapper mrec_placeHolder">
                    <AdCaller
                      data={{
                        name: 'mrec',
                        adCode: data.adCode,
                        size: [300, 250],
                        divId: '637c6e6bcdd25404cdac0746-mrec',
                      }}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      {data &&
        data.btfContent &&
        !hideBtf && (
          <Text
            text={data.btfContent}
            background={isWapView ? '' : 'coronahomepage'}
            isdangerouslySetInnerHTML
          />
        )}
    </>
  );
};

BoardForm.propTypes = {
  hideBtf: PropTypes.bool,
  userData: PropTypes.shape({}),
};

BoardForm.defaultProps = {
  hideBtf: false,
  userData: undefined,
};

const mapStateToProps = state => ({
  userData: _get(state, 'login.userData', {}),
});

export default connect(mapStateToProps)(BoardForm);
